<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/institution-list">会员风采</router-link></li>
                <li class="currentNode"><a>企业风采</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>会员风采</a></li>
                    <li><router-link to="/layout/institution-list">驻京办风采</router-link></li>
                    <li><router-link to="/layout/company-list" class="active">企业风采</router-link></li>
                    <!-- <li><router-link to="/layout/city-food">驻京美食</router-link></li> -->
                    <li><router-link to="/layout/good-product-list">名特优产品</router-link></li>
                    <li><router-link to="/layout/cultural-heritage-list">非物质文化遗产</router-link></li>
                </ul>
                <div class="page-content">
                    <h3>企业风采</h3>
                    <ul class="branch-list">
                        <li class="branch-item" v-for="branch in branchList" :key="branch.CompanyId" @click="goDetail(branch)">
                            <img :src="branch.Logo" />
                            <div class="branch-item-memo">
                                <h4>{{ branch.CompanyName }}</h4>
                                <p class="ellipsis_two">{{ branch.ShopIntroduction }}</p>
                            </div>
                        </li>
                        <!-- <li class="branch-item">
                            <img src="@/assets/image/enterprise/informationBranch1.png" />
                            <div class="branch-item-memo">
                                <h4>北京趣拿信息技术有限公司</h4>
                                <p>技术推广；软件开发；数字技术服务；数据处理服务；会议及展览服务；社会经济咨询服务。</p>
                            </div>
                        </li> -->
                    </ul>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div> 
        </div>
    </div>
</template>

<script>
import {
    getCompanyList
} from '@services/indexService.js';
export default {
    name:"",
    data() {
        return {
            branchList:[],
            total: 100,
            currentPage: 1,
            pageSize: 10,
            type: 1, // 信息工作部1，双招双引工作部2，医疗卫生工作部3，企业工作部4
         
        }
    },
    created() {
        if (this.$route.query.page) {
            this.currentPage = Number(this.$route.query.page);
        }
        this.getCompanyList();
    },
    methods: {
        getCompanyList() {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
                type: this.type
            };
            getCompanyList(params).then(res => {
                console.log(res);
                if (res.Code == 1 && res.Data.length!==0) {
                    this.branchList = res.Data;
                    this.total = res.Count;
                } else {
                    this.$message.error("协会要问请求失败");
                }
            })

        },
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path:'/layout/company-detail',
                query: {
                    id: data.CompanyId,
                    page: this.currentPage
                }
            });
            window.open(newUrl.href, '_blank');
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getCompanyList();
        }
    }
}
</script>

<style scoped>
/* .page-main {
    display: block;
    background: #fff;
    padding: 30px 56px;
    box-sizing: border-box;
} */
.page-main h3{
    text-align:center;
}
.branch-list {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 10px;
    padding-top: 20px;
}
.branch-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 15px;
    margin-right:20px;
    width: 458px;
    height: 100px;  
    cursor: pointer;
    margin-right: 40px;
}
.branch-item:hover h4,
.branch-item:hover p{
    color: #116EBA;
}
.branch-list .branch-item:nth-child(2n) {
    margin-right:0;
}
.branch-item img {
    width: 100px;
    height: 100px;
    border: 1px solid #E5E5E5;
}
.branch-item-memo {
    padding: 15px;
}
.branch-item-memo h4 {
    font-family: 思源黑体 CN;
    font-size: 18px;
    color: #262626;
    margin-bottom: 10px;
}
.branch-item-memo p {
    font-family: 思源黑体 CN;
    font-size: 14px;
    color: #6A6A6A;
    line-height: 22px;
}
.branch-item-tip {
    display:flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
}
.branch-item-tip .doing {
    color: #4DC514;

}
.branch-item-tip .date {
    color: #A1A8B0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.branch-item-tip .date img {
    width: 15px;
    height: 15px;
}
.branch-item-tip .date i{
    font-style: normal;
    padding-left: 6px;
}
.el-divider--horizontal {
    margin: 10px 0;
}
</style>